/**
 * cookieUtils.ts
 *
 * Cookie 読み書きの汎用ユーティリティ。
 * DayListReservations / VehicleList で繰り返されていたパターンを一元化。
 */

/**
 * Cookie から JSON 値を読み込む
 * @param key - Cookie のキー名
 * @param defaultValue - 読み込み失敗時のデフォルト値
 * @returns パース済みの値、または defaultValue
 */
export function loadFromCookie<T>(key: string, defaultValue: T | null = null): T | null {
  try {
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith(`${key}=`));
    if (cookieValue) {
      const decoded = decodeURIComponent(cookieValue.split('=')[1]);
      return JSON.parse(decoded) as T;
    }
  } catch (e) {
    console.error(`Failed to load cookie "${key}":`, e);
  }
  return defaultValue;
}

/**
 * JSON 値を Cookie に保存する
 * @param key - Cookie のキー名
 * @param value - 保存する値（JSON シリアライズ可能なもの）
 * @param days - 有効期限（日数）
 */
export function saveJsonToCookie(key: string, value: unknown, days: number = 30): void {
  try {
    const encoded = encodeURIComponent(JSON.stringify(value));
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${key}=${encoded}; expires=${expires}; path=/`;
  } catch (e) {
    console.error(`Failed to save cookie "${key}":`, e);
  }
}
